<template>
  <path
    d="M5 11.8258L5 4.17422C5 3.31987 6.00212 2.85896 6.65079 3.41496L11.1142 7.24074C11.5798 7.63984 11.5798 8.36016 11.1142 8.75926L6.65079 12.585C6.00212 13.141 5 12.6801 5 11.8258Z"
  />
</template>
